import { render, staticRenderFns } from "./ConcatUs.vue?vue&type=template&id=41391c60&scoped=true"
import script from "./ConcatUs.vue?vue&type=script&lang=js"
export * from "./ConcatUs.vue?vue&type=script&lang=js"
import style0 from "./ConcatUs.vue?vue&type=style&index=0&id=41391c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41391c60",
  null
  
)

export default component.exports